/*
 * メッセージ表示用 定義コンポーネント
 * 共通部品
 */
<template>
	<div>
		<div v-for="messages in r_errors" >
			{{messages}}
		</div>
	</div>
</template>
<script>
	/**
	 * メッセージ表示用 定義コンポーネント.<br>
	 * @module js\parts_unit\MessageList
	 * @example
	 * <c-message 
	 * 	:messages="rec" 
	 * >
	 * </c-message>
	 **/

	/**
	 * props 引数
	 * @param {string[]} r_errors - エラーメッセージ
	 **/
	 export default {
		props:[
			'r_errors',
		],
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/MessageList.vue